var LabelDataBuilder = /** @class */ (function () {
    function LabelDataBuilder() {
        this.label = {
            id: '12312-boobob-21300321-0b0b0b',
            name: 'bob label'
        };
    }
    LabelDataBuilder.prototype.withId = function (id) {
        this.label.id = id;
        return this;
    };
    LabelDataBuilder.prototype.withName = function (name) {
        this.label.name = name;
        return this;
    };
    LabelDataBuilder.prototype.build = function () {
        return this.label;
    };
    return LabelDataBuilder;
}());
export { LabelDataBuilder };
//# sourceMappingURL=label-data.js.map